import { useQuery } from "@tanstack/react-query";
import {
  buildNewPurchaseOrderDetailsPayload,
  fetchNewPurchaseOrderDetails,
} from "../../services/purchaseOrders/purchaseOrdersApi";
import { poQueryCache } from "./cacheTimes";
import { purchaseOrderKeys } from "./queryKeys";

/** new_purchase_order_details — single PO for the detail page. */
export function useNewPurchaseOrderDetailsQuery({
  merchantId,
  poId,
  auth,
  storeIds,
  enabled = true,
}) {
  return useQuery({
    queryKey: purchaseOrderKeys.detail(merchantId, poId),
    queryFn: ({ signal }) =>
      fetchNewPurchaseOrderDetails(
        buildNewPurchaseOrderDetailsPayload(auth, merchantId, poId, storeIds),
        signal
      ),
    enabled: Boolean(enabled && merchantId && poId && auth?.token),
    ...poQueryCache.live,
    refetchOnMount: "always",
    retry: 1,
  });
}
